import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { tdpSkillsTelemetryApiRef } from './api/TdpSkillsTelemetryApi';
import { TdpSkillsTelemetryClient } from './api/TdpSkillsTelemetryClient';

export const tdpSkillsTelemetryPlugin = createPlugin({
  id: 'tdp-skills-telemetry',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: tdpSkillsTelemetryApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new TdpSkillsTelemetryClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const TdpSkillsTelemetryPage = tdpSkillsTelemetryPlugin.provide(
  createRoutableExtension({
    name: 'TdpSkillsTelemetryPage',
    component: () =>
      import('./components/TdpSkillsTelemetryPage').then(m => m.TdpSkillsTelemetryPage),
    mountPoint: rootRouteRef,
  }),
);
